import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    redirect: { name: "Categories" },
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/categories/add",
    name: "AddCategories",
    component: () => import("@/views/categories/AddCategories.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/categories",
    name: "Categories",
    component: () => import("@/views/categories/Categories.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/categories/search",
    name: "CategoriesQuickSearch",
    component: () => import("@/views/categories/CategoriesQuickSearch.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/attributes/search",
    name: "AttributesQuickSearch",
    component: () => import("@/views/attributes/AttributesQuickSearch.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/attributes",
    name: "Attributes",
    component: () => import("@/views/attributes/ListAttributes.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/attributes/add",
    name: "AddAttribute",
    component: () => import("@/views/attributes/AddAttribute.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/importcsv/:importName",
    name: "ImportCsv",
    component: () => import("@/views/ImportCsv.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/exportcsv/:exportName",
    name: "ExportCsv",
    component: () => import("@/views/ExportCsv.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/categories/:id",
    name: "EditCategory",
    component: () => import("@/views/categories/edit/EditCategory.vue"),
    props: ({ params }) => ({ id: Number.parseInt(params.id, 10) || 0 }),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/attributes/edit/:id",
    name: "EditAttribute",
    component: () => import("@/views/attributes/EditAttribute.vue"),
    props: ({ params }) => ({
      id: Number.parseInt(params.id, 10) || 0
    }),
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters["users/isAuthenticated"]) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else {
    if (to.name === "Login" && store.getters["users/isAuthenticated"]) {
      next({ name: "Home" });
    } else {
      next();
    }
  }
});

export default router;
